var _a;
export var STYLABLE = {
    GALLERY: "controllers_stylableOptions_gallery",
    CONTAINER: "controllers_stylableOptions_container",
    ITEM: "controllers_stylableOptions_item",
    ITEM_HOVER: "controllers_stylableOptions_itemHover",
    ITEM_OVERLAY: "controllers_stylableOptions_itemOverlay",
    ITEM_OVERLAY_HOVER: "controllers_stylableOptions_itemOverlayHover",
    ITEM_CONTENT: "controllers_stylableOptions_itemContent",
    ITEM_CONTENT_HOVER: "controllers_stylableOptions_itemContentHover",
    INNER_TITLE: "controllers_stylableOptions_innerTitle",
    CONTROLLERS_EXPERIMENTAL_USENEWINFO: "controllers_experimental_useNewInfo",
    INNER_DESCRIPTION: "controllers_stylableOptions_innerDescription",
    EXTERNAL_TITLE: "controllers_stylableOptions_externalTitle",
    EXTERNAL_DESCRIPTION: "controllers_stylableOptions_externalDescription",
    INNER_TITLE_REGULAR: "controllers_stylableOptions_innerTitleRegular",
    INNER_TITLE_HOVER: "controllers_stylableOptions_innerTitleHover",
    INNER_DESCRIPTION_REGULAR: "controllers_stylableOptions_innerDescriptionRegular",
    INNER_DESCRIPTION_HOVER: "controllers_stylableOptions_innerDescriptionHover",
    EXTERNAL_TITLE_REGULAR: "controllers_stylableOptions_externalTitleRegular",
    EXTERNAL_TITLE_HOVER: "controllers_stylableOptions_externalTitleHover",
    EXTERNAL_DESCRIPTION_REGULAR: "controllers_stylableOptions_externalDescriptionRegular",
    EXTERNAL_DESCRIPTION_HOVER: "controllers_stylableOptions_externalDescriptionHover",
    LOAD_MORE: "controllers_stylableOptions_loadMore",
};
export var STYLABLE_CONTROLLERS_DATA = (_a = {},
    _a[STYLABLE.GALLERY] = {
        key: STYLABLE.GALLERY,
        type: 'STYLABLE',
        features: ['FILL', 'SHADOW', 'CORNERS'],
        selector: '.root',
        title: 'Native_ProGallery_Design_Option1_Container',
    },
    _a[STYLABLE.CONTAINER] = {
        key: STYLABLE.CONTAINER,
        type: 'STYLABLE',
        features: ['FILL', 'SHADOW', 'CORNERS', 'BORDERS'],
        selector: '.root::pro-gallery-container',
        title: 'Native_ProGallery_Design_Option1_Container',
    },
    _a[STYLABLE.ITEM] = {
        key: STYLABLE.ITEM,
        type: 'STYLABLE',
        features: ['FILL', 'BORDERS', 'SHADOW', 'CORNERS'],
        selector: '.root::item',
        title: 'Native_ProGallery_Design_Option2_Item',
        description: 'StylablePanel_Design_State_Dropdown_Regular',
    },
    _a[STYLABLE.ITEM_HOVER] = {
        key: STYLABLE.ITEM_HOVER,
        type: 'STYLABLE',
        features: ['FILL', 'BORDERS', 'SHADOW', 'CORNERS'],
        selector: '.root::item:hover',
        title: 'Native_ProGallery_Design_Option2_Item',
        description: 'StylablePanel_Design_State_Dropdown_Hover',
    },
    _a[STYLABLE.ITEM_OVERLAY] = {
        key: STYLABLE.ITEM_OVERLAY,
        type: 'STYLABLE',
        features: ['FILL', 'BORDERS', 'SHADOW', 'CORNERS'],
        selector: '.root::item::overlay',
        title: 'Native_ProGallery_Design_Option2_Item_Overlay',
        description: 'StylablePanel_Design_State_Dropdown_Regular',
    },
    _a[STYLABLE.ITEM_OVERLAY_HOVER] = {
        key: STYLABLE.ITEM_OVERLAY_HOVER,
        type: 'STYLABLE',
        features: ['FILL', 'BORDERS', 'SHADOW', 'CORNERS'],
        selector: '.root::item:hover::overlay',
        title: 'Native_ProGallery_Design_Option2_Item_Overlay',
        description: 'StylablePanel_Design_State_Dropdown_Hover',
    },
    _a[STYLABLE.ITEM_CONTENT] = {
        key: STYLABLE.ITEM_CONTENT,
        type: 'STYLABLE',
        features: ['FILL', 'BORDERS', 'SHADOW', 'CORNERS'],
        selector: '.root::item::content',
        title: 'Native_ProGallery_Design_Option2_Item_Content',
        description: 'StylablePanel_Design_State_Dropdown_Regular',
    },
    _a[STYLABLE.ITEM_CONTENT_HOVER] = {
        key: STYLABLE.ITEM_CONTENT_HOVER,
        type: 'STYLABLE',
        features: ['FILL', 'BORDERS', 'SHADOW', 'CORNERS'],
        selector: '.root::item:hover::content',
        title: 'Native_ProGallery_Design_Option2_Item_Content',
        description: 'StylablePanel_Design_State_Dropdown_Hover',
    },
    _a[STYLABLE.INNER_TITLE] = {
        key: STYLABLE.INNER_TITLE,
        type: 'STYLABLE',
        features: ['TEXT', 'BORDERS', 'FILL', 'CORNERS', 'LAYOUT'],
        selector: '.root::item-hover-info-title',
        title: 'Native_ProGallery_Design_Option6_Hover_Title',
    },
    _a[STYLABLE.INNER_DESCRIPTION] = {
        key: STYLABLE.INNER_DESCRIPTION,
        type: 'STYLABLE',
        features: ['TEXT', 'BORDERS', 'FILL', 'CORNERS', 'LAYOUT'],
        selector: '.root::item-hover-info-description',
        title: 'Native_ProGallery_Design_Option7_Hover_Description',
    },
    _a[STYLABLE.EXTERNAL_TITLE] = {
        key: STYLABLE.EXTERNAL_TITLE,
        type: 'STYLABLE',
        features: ['TEXT', 'BORDERS', 'FILL', 'CORNERS', 'LAYOUT'],
        selector: '.root::item-external-info-title',
        title: 'Native_ProGallery_Design_Option4_Ext_Title',
    },
    _a[STYLABLE.EXTERNAL_DESCRIPTION] = {
        key: STYLABLE.EXTERNAL_DESCRIPTION,
        type: 'STYLABLE',
        features: ['TEXT', 'BORDERS', 'FILL', 'CORNERS', 'LAYOUT'],
        selector: '.root::item-external-info-description',
        title: 'Native_ProGallery_Design_Option5_Ext_Description',
    },
    _a[STYLABLE.INNER_TITLE_REGULAR] = {
        key: STYLABLE.INNER_TITLE_REGULAR,
        type: 'STYLABLE',
        features: ['TEXT', 'BORDERS', 'FILL', 'CORNERS', 'LAYOUT'],
        selector: '.root::item::item-hover-info-title',
        title: 'Native_ProGallery_Design_Option6_Hover_Title',
        description: 'StylablePanel_Design_State_Dropdown_Regular',
    },
    _a[STYLABLE.INNER_TITLE_HOVER] = {
        key: STYLABLE.INNER_TITLE_HOVER,
        type: 'STYLABLE',
        features: ['TEXT', 'BORDERS', 'FILL', 'CORNERS', 'LAYOUT'],
        selector: '.root::item:hover::item-hover-info-title',
        title: 'Native_ProGallery_Design_Option6_Hover_Title',
        description: 'StylablePanel_Design_State_Dropdown_Hover',
    },
    _a[STYLABLE.INNER_DESCRIPTION_REGULAR] = {
        key: STYLABLE.INNER_DESCRIPTION_REGULAR,
        type: 'STYLABLE',
        features: ['TEXT', 'BORDERS', 'FILL', 'CORNERS', 'LAYOUT'],
        selector: '.root::item::item-hover-info-description',
        title: 'Native_ProGallery_Design_Option7_Hover_Description',
        description: 'StylablePanel_Design_State_Dropdown_Regular',
    },
    _a[STYLABLE.INNER_DESCRIPTION_HOVER] = {
        key: STYLABLE.INNER_DESCRIPTION_HOVER,
        type: 'STYLABLE',
        features: ['TEXT', 'BORDERS', 'FILL', 'CORNERS', 'LAYOUT'],
        selector: '.root::item:hover::item-hover-info-description',
        title: 'Native_ProGallery_Design_Option7_Hover_Description',
        description: 'StylablePanel_Design_State_Dropdown_Hover',
    },
    _a[STYLABLE.EXTERNAL_TITLE_REGULAR] = {
        key: STYLABLE.EXTERNAL_TITLE_REGULAR,
        type: 'STYLABLE',
        features: ['TEXT', 'BORDERS', 'FILL', 'CORNERS', 'LAYOUT'],
        selector: '.root::item::item-external-info-title',
        title: 'Native_ProGallery_Design_Option4_Ext_Title',
        description: 'StylablePanel_Design_State_Dropdown_Regular',
    },
    _a[STYLABLE.EXTERNAL_TITLE_HOVER] = {
        key: STYLABLE.EXTERNAL_TITLE_HOVER,
        type: 'STYLABLE',
        features: ['TEXT', 'BORDERS', 'FILL', 'CORNERS', 'LAYOUT'],
        selector: '.root::item:hover::item-external-info-title',
        title: 'Native_ProGallery_Design_Option4_Ext_Title',
        description: 'StylablePanel_Design_State_Dropdown_Hover',
    },
    _a[STYLABLE.EXTERNAL_DESCRIPTION_REGULAR] = {
        key: STYLABLE.EXTERNAL_DESCRIPTION_REGULAR,
        type: 'STYLABLE',
        features: ['TEXT', 'BORDERS', 'FILL', 'CORNERS', 'LAYOUT'],
        selector: '.root::item::item-external-info-description',
        title: 'Native_ProGallery_Design_Option5_Ext_Description',
        description: 'StylablePanel_Design_State_Dropdown_Regular',
    },
    _a[STYLABLE.EXTERNAL_DESCRIPTION_HOVER] = {
        key: STYLABLE.EXTERNAL_DESCRIPTION_HOVER,
        type: 'STYLABLE',
        features: ['TEXT', 'BORDERS', 'FILL', 'CORNERS', 'LAYOUT'],
        selector: '.root::item:hover::item-external-info-description',
        title: 'Native_ProGallery_Design_Option5_Ext_Description',
        description: 'StylablePanel_Design_State_Dropdown_Hover',
    },
    _a[STYLABLE.LOAD_MORE] = {
        key: STYLABLE.LOAD_MORE,
        type: 'STYLABLE',
        features: ['TEXT', 'FILL', 'BORDERS', 'SHADOW', 'CORNERS'],
        selector: '.root::loadmore',
        title: 'Native_ProGallery_Design_Option3_LoadMoreBtn',
    },
    _a);
//# sourceMappingURL=stylable.js.map